import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import PdfView from './PdfView';
import 'swiper/css';
import '../style/industrialPolicy.css';
const type_c_1 = require('../assets/type_c_1.png')
const type_c_2 = require('../assets/type_c_2.png')
const type_c_3 = require('../assets/type_c_3.png')
const type_1 = require('../assets/type_1.png')
const type_2 = require('../assets/type_2.png')
const type_3 = require('../assets/type_3.png')

function InDevelopment() {
    // pdf弹窗
    const [isOpen, setIsOpen] = useState(false);
    // 侧边政策
    const [typeList, setTypeList] = useState([
        {
            pic: type_1,
            pic_c: type_c_1
        },
        {
            pic: type_2,
            pic_c: type_c_2
        },
        {
            pic: type_3,
            pic_c: type_c_3
        }
    ])
    // 选中政策
    const [cZc, setCZc] = useState(0);
    // 政策类型
    const [tabList, setTabList] = useState([])
    // 选中政策类型
    const [cMenu, setCMenu] = useState(0);
    // 新闻数据
    const [dataList, setDataList] = useState([
        {
            id: 11,
            name: '只是一个很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长的文字只是一个很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长的文字'
        },
        {
            id: 22,
            name: '只是一长很长很长很长的文字只是一个很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长的文字'
        },
        {
            id: 33,
            name: '只是一很长很长很长很长很长很长的文字只是一个很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长的文字'
        },
        {
            id: 44,
            name: '只是一个很长很长很长很长很长很长很长很长很长很长的文字只是一个很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长很长的文字'
        }
    ])
    // 默认展示菜单个数
    const [slidesPerView, setSlidesPerView] = useState(6);
    // 获取侧边栏政策数据
    const getSideList = async () => {
        try {
            const response = await fetch('http://116.62.141.180/api/web/types');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            typeList.map((item, i) => {
                Object.assign(item, jsonData.datas[i])
                return item;
            })
            // 回填侧边栏数据
            setTypeList(typeList);
            // 设置选中侧边栏状态
            setCZc(0);
            // 类型数据获取填入
            setTabList(typeList[0].subs);
            // 初始化默认获取第一个类型的数据
            getType(typeList[0].subs[0].id);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // 打开类型数据的pdf文件链接
    const [pdfUrl, setPdfUrl] = useState('');
    // 设置打开pdf弹窗标题
    const [pdfTitle, setPdfTitle] = useState('');
    // 获取类型数据
    const getType = async (id) => {
        try {
            const response = await fetch(`http://116.62.141.180/api/web/files?subs_id=${id}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setDataList(jsonData.datas);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        // 手机端设置菜单展示个数
        if (window.innerWidth > 768) {
            setSlidesPerView(9);
        } else {
            setSlidesPerView(3);
        }
        // 在组件挂载时进行数据请求
        getSideList();
    }, [useEffect]);

    return (
        <div className="industrialPolicy">
            <div className="industrialPolicy-wrapper">
                <div className="industrialPolicy-site-type">
                    {
                        typeList.map((item, i) => (
                            <div
                                className={`industrialPolicy-site-type__item ${i === cZc ? 'active' : ''}`}
                                key={i}
                                onClick={() => {
                                    setCZc(i)
                                    setTabList(typeList[i].subs)
                                    setCMenu(0)
                                    getType(typeList[i].subs[0] ? typeList[i].subs[0].id : setDataList([]))
                                }}
                            >
                                <img
                                    className="industrialPolicy-site-type__item--img"
                                    src={i === cZc ? item.pic_c : item.pic} alt="type"
                                />
                                <span className="industrialPolicy-site-type__item--name">{item.name}</span>
                            </div>
                        ))
                    }
                </div>
                <div className="industrialPolicy-body">
                    <Swiper
                        className="industrialPolicy-body__tabs"
                        slidesPerView={slidesPerView}
                    >
                        {
                            tabList.map((item, i) => (
                                <SwiperSlide
                                    className={`industrialPolicy-body__tabs--item ${i === cMenu ? 'active' : ''}`}
                                    key={item.id}
                                    onClick={() => {
                                        setCMenu(i)
                                        getType(item.id)
                                    }}
                                >
                                    <span className="item-name">{item.name}</span>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                    <div className="industrialPolicy-body__text">
                        {
                            dataList.map((item, i) => (
                                <p
                                    className="industrialPolicy-body__text-t"
                                    key={i}
                                    onClick={() => {
                                        if (item.classify === 1) {
                                            window.open(`${item.url}`, '_target')
                                        } else {
                                            setPdfUrl(item.domain + item.url)
                                            setIsOpen(!isOpen)
                                            setPdfTitle(item.name)
                                        }
                                    }}
                                >
                                    {i + 1}. {item.name}
                                </p>
                            ))
                        }
                    </div>
                </div>
            </div>
            {
                isOpen && <PdfView isClose={isOpen} pdf={pdfUrl} title={pdfTitle} onOpen={(props) => { setIsOpen(props) }} />
            }
        </div>
    );
}

export default InDevelopment;
